import {css} from '@emotion/react'
import {Button} from 'antd'
import {FileIcon, defaultStyles} from 'react-file-icon'
import {humanReadableSize, getExt} from '@/script/file.mjs'
import openWindow from '@/script/openWindow.mjs'
import IconDelete from './icon-delete.svg?react'

const cssFile = css({
    display: 'inline-grid',
    gridTemplateRows: 'auto auto',
    gridTemplateColumns: 'auto auto',
    gap: 8,
    height: 'auto',
    lineHeight: 1,
    backgroundColor: 'rgb(243, 244, 246)',
    padding: 12,
    border: 'none',
    borderRadius: 12,

    ':hover': {
        backgroundColor: 'rgb(243, 244, 246)',
        boxShadow: '0px 0px 0px .5px #dce0e9,0px 4px 8px 0px rgba(144,150,174,.25)',
    },
})

const cssFileIcon = css({
    gridRow: '1 / -1',
    width: 24,
})

const cssFileName = css({
    fontSize: 14,
    color: 'rgb(38, 38, 38)',
    maxWidth: 160,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
})

const cssFileMeta = css({
    fontSize: 12,
    color: 'rgb(187, 187, 187)',
    textAlign: 'left',
})

const cssButtonDelete = css({
    position: 'absolute',
    top: - 5,
    right: - 5,
    appearance: 'none',
    backgroundColor: '#fff',
    lineHeight: 0,
    padding: 6,
    border: 'none',
    borderRadius: '50%',
    boxShadow: '0 1px 2px rgba(148,147,147,.25),inset 0 0 0 .5px #ededed',
})

const ButtonDelete = ({onClick, ...props}) => {
    if (! onClick) {
        return null
    }

    const _onClick = e => {
        e.stopPropagation()
        onClick()
    }

    return (
        <button
            css={cssButtonDelete}
            title="删除"
            onClick={_onClick}
            {...props}
        >
            <IconDelete />
        </button>
    )
}

const File = ({file, onClick, onDelete, ...props}) => {
    const {name, size} = file
    const ext = getExt(name).toUpperCase()
    const _onDelete = onDelete ? () => onDelete(file) : null

    return (
        <Button
            css={cssFile}
            title={name}
            onClick={onClick}
            {...props}
        >
            <div css={cssFileIcon}>
                <FileIcon
                    color={'rgb(219, 234, 254)'}
                    extension={ext}
                    {...defaultStyles[ext]}
                />
            </div>

            <div css={cssFileName}>
                {name}
            </div>

            <div css={cssFileMeta}>
                {ext}: {humanReadableSize(size)}
            </div>

            <ButtonDelete onClick={_onDelete} />
        </Button>
    )
}

export const LocalFile = ({file, ...props}) => {
    const onClick = () => {
        const url = URL.createObjectURL(file)
        window.open(url)
        URL.revokeObjectURL(url)
    }

    return (
        <File
            file={file}
            onClick={onClick}
            {...props}
        />
    )
}

export const RemoteFile = ({file, ...props}) => {
    const onClick = () => openWindow(file.src)

    return (
        <File
            file={file}
            onClick={onClick}
            {...props}
        />
    )
}
